<template>
    <span class="kioskMyPlace">
        <div class="topFlo" v-if="!$store.state.kioskEvent.isConference"></div>
        <h1>{{ $store.state.kioskEvent.name }}</h1>
        <div class="searchWrap">
			<div class="inputWrap searchWrapper">
				<input type="search" v-bind:placeholder="$t('whatIsYourName')" v-model="search" id="searchInput">
                <button class="closeBtn" style="position:absolute;left:40px;top:30px;opacity: 0.4;cursor: pointer;" v-if="search !== ''" @click="search=''"><svg class="i_close" style="height:40px;width:40px"><use xlink:href="#i_close"></use></svg></button>
				<button class="searchEvent">
					<span class="sr-only">{{ $t('whatIsYourName') }}</span>
				</button>
			</div>
		</div>
		<div class="mainImgWrap" style="overflow: hidden">
			<div class="listWrap scrollerWrap" style="overflow: hidden">
				<ul>
					<router-link @click.native="handleClick('/guests/myPlace/'+guest.id)" event="" v-bind:to="'/guests/myPlace/'+guest.id" tag="li" v-for="guest of getGuests().sort( (a,b)=>a.fullName.toString().localeCompare(b.fullName.toString()) )" :key="guest.id">{{ guest.fullName }}</router-link>
                    <li v-if="getGuests().length ===0" style="text-align: center">{{ $t('noGuestFound') }}</li>
				</ul>
			</div>
		</div>
		<KioskFooter active="myPlace"></KioskFooter>
        <div class="bottomMenuWrap">
            <KioskLanguageSelector></KioskLanguageSelector>
            <AdminMenu v-on:openMenu="adminMenuOpened = true"></AdminMenu>
            <button class="adminEnt" @click.prevent="showArrivalStatus()">
                <Clock  />
            </button>
            <KioskArrivalStatus v-if="arrivalStatusOpened" v-on:close="arrivalStatusOpened = false"></KioskArrivalStatus>
        </div>
        <EventSelectModal @setEvent="setEvent" v-if="!$store.state.kioskEvent.id"></EventSelectModal>
        <AdminMenu :modal="true" v-if="adminMenuOpened" v-on:closeMenu="closeMenu"></AdminMenu>
        <Keyboard></Keyboard>
    </span>
</template>

<script>
    import KioskFooter from '../Kiosk/KioskFooter'
    import KioskLanguageSelector from '../Kiosk/KioskLanguageSelector'
    import EventSelectModal from '../Modals/EventSelectModal'
    import AdminMenu from '../Modals/AdminMenu'
    import Clock from 'vue-digital-clock'
    import Keyboard from './Keyboard'
    import KioskArrivalStatus from './KioskArrivalStatus'
    export default {
        name: "KioskMyPlace",
        components:{
            KioskLanguageSelector,
            EventSelectModal,
            AdminMenu,
            Clock,
            KioskFooter,
            Keyboard,
            KioskArrivalStatus
        },
        data(){
            return {
                adminMenuOpened:false,
                lastScroll:250,
                arrivalStatusOpened:false,
                search:''
            }
        },
        destroyed(){
            try{
                $(".scrollerWrap").getNiceScroll().remove();
                $(".scrollerWrap").unbind("scroll");
            }
            catch(e){
                console.warn('failed to destroy nicescroll')
            }
        },
        mounted(){
            $('body').addClass('kioskView')
            let _this = this;
            if(!this.$store.state.kioskEvent.id) {
                this.$router.push('/')
            }else{
                this.processKiosk();
            }

            $("#searchInput").off('change').on('change',function(){
                setTimeout(function(){
                    _this.search = $("#searchInput").val()
                },50);
            });

            $(".scrollerWrap").bind("scroll",function(){
               _this.lastScroll = Date.now();
            });

        },
        methods:{
            handleClick(link) {
                const lastScroll = this.lastScroll !== "" ? Date.now()-this.lastScroll : 250;
                if(lastScroll >= 250) this.$router.push(link);
            },
            closeMenu(){
                this.adminMenuOpened = false;
                this.clicksCounter = 0;
            },
            setEvent(eventID){
                this.$store.state.kioskEvent = this.$store.state.closestEvents.filter(event => {
                    if(event.id == eventID) return true;
                    return false;
                }).pop();
                if(this.$store.state.kioskEvent.id){
                    this.processKiosk();
                }else{
                    this.$store.dispatch('logoff')
                }
            },
            getGuests(){
                return (!this.$store.state.kioskEvent.guests ? [] : this.$store.state.kioskEvent.guests.filter(guest=>{
                    if(this.search != '' && !guest.fullName.toLowerCase().includes(this.search)) return false;
                   return true;
                }));
            },
            showArrivalStatus(){
                this.arrivalStatusOpened = !this.arrivalStatusOpened;
                const _this = this;
                setTimeout(function(){ _this.arrivalStatusOpened = false },5000);
            },
            processKiosk(){

                if(typeof $(".scrollerWrap").niceScroll !=='function') {
                    $.getScript("/static/js/niceScroll.min.js", function () {
                        $(".scrollerWrap").niceScroll({smoothscroll:true,hwacceleration:true,emulatetouch:true,grabcursorenabled:true,  cursordragontouch: true,cursordragontouch:true})
                    });
                }
                else{
                    $(".scrollerWrap").niceScroll({smoothscroll:true,hwacceleration:true,emulatetouch:true,grabcursorenabled:true,  cursordragontouch: true,cursordragontouch:true})
                }

            },
        }
    }
</script>
<style scoped>
    ::-webkit-scrollbar {
        width: 0px;  /* remove scrollbar space */
        background: transparent;  /* optional: just make scrollbar invisible */
    }
    /* optional: show position indicator in red */
    ::-webkit-scrollbar-thumb {
        background: #FF0000;
    }
</style>
